import { render } from "./ArrendamientosDetallePage.vue?vue&type=template&id=6f4b35c3"
import script from "./ArrendamientosDetallePage.vue?vue&type=script&lang=js"
export * from "./ArrendamientosDetallePage.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/Proyectos/Vue/cotizador-ventus/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__